import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
/**
 * Interactive grid picker component for selecting viewport layouts
 * Click a cell to select that grid size (e.g., click [2,2] = 2x2 layout)
 */
export function GridPicker({ value, onChange, maxRows = 4, maxCols = 4 }) {
    const { t } = useTranslation('settings');
    const [hovered, setHovered] = useState(null);
    const displayValue = hovered || value;
    const isSelected = (row, col) => {
        return row <= value.rows && col <= value.cols;
    };
    const isHovered = (row, col) => {
        if (!hovered)
            return false;
        return row <= hovered.rows && col <= hovered.cols;
    };
    return (_jsxs("div", { className: "inline-block", children: [_jsx("div", { className: "bg-muted/50 grid gap-1 rounded-lg p-2", style: {
                    gridTemplateColumns: `repeat(${maxCols}, 1fr)`,
                    gridTemplateRows: `repeat(${maxRows}, 1fr)`,
                }, onPointerLeave: () => setHovered(null), "data-testid": "grid-picker", children: Array.from({ length: maxRows }, (_, rowIdx) => Array.from({ length: maxCols }, (_, colIdx) => {
                    const row = rowIdx + 1;
                    const col = colIdx + 1;
                    const selected = isSelected(row, col);
                    const hoveredCell = isHovered(row, col);
                    return (_jsx("button", { type: "button", onClick: () => onChange({ rows: row, cols: col }), 
                        // Preview on mouse hover only. A tap fires a compatibility
                        // mouseenter that nothing ever cancels, which left the chosen
                        // cells in the hover style instead of the selected ring.
                        onPointerEnter: (e) => {
                            if (e.pointerType === 'mouse')
                                setHovered({ rows: row, cols: col });
                        }, className: `h-7 w-7 rounded transition-all duration-100 pointer-coarse:h-9 pointer-coarse:w-9 ${selected && !hovered
                            ? 'bg-primary ring-primary/50 ring-1'
                            : hoveredCell
                                ? 'bg-primary/60'
                                : 'bg-muted-foreground/20 hover:bg-muted-foreground/30'} `, "aria-label": t('viewer.gridPicker.selectLayout', { rows: row, cols: col }) }, `${row}-${col}`));
                })) }), _jsxs("div", { className: "mt-2 text-center", children: [_jsx("span", { className: "text-foreground font-medium", children: t('viewer.gridPicker.dimensions', { rows: displayValue.rows, cols: displayValue.cols }) }), _jsxs("span", { className: "text-muted-foreground ml-2 text-sm", children: ["(", t('viewer.gridPicker.viewportCount', { count: displayValue.rows * displayValue.cols }), ")"] })] })] }));
}
